import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocationsService } from '@app/services/locations/locations.service';
import { ILocation } from '@app/models/location.interface';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions';

@Component({
  selector: 'app-delete-location-modal',
  templateUrl: './delete-location-modal.component.html',
  styleUrls: ['./delete-location-modal.component.scss']
})

export class DeleteLocationModalComponent implements OnInit {
  public location_id: any;
  public counts_users: any;
  public location_list$: ILocation[];
  public form: FormGroup;

  constructor(
    public fb: FormBuilder,
    private store$: Store,
    private _matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _locations: LocationsService
  ) { 
    this.location_id = data.location_id;
    this.counts_users = data.counts_users;
    this.form = this.fb.group({
      usrLocations: new FormControl(''),
    });

    this._locations.onGetLocations('locName', 'asc').subscribe((res:any) => { 
      this.location_list$ = res.data.locations
      .filter(location => location.locID !== this.location_id) 
      .map(location => {
        return {
          ...location
        };
      });
    });
  
  }

  ngOnInit(): void {
  }

  onSubmit() {
    let current_location = this.location_id;
    let new_location = this.form.value.usrLocations;
    this.store$.dispatch(OrganizationActions.assignNewLocation({ current_location: current_location, new_location: new_location }));
    this._matDialog.closeAll();    
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  isValid(form) {
    if (form.valid == false) {
      return true;
    }

    form.markAsPristine();
    return false;
  }

}

